module.exports = __webpack_public_path__ + "static/media/pl-windows.68e2c533.png";